import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Props {
  count: number;
}

export default function PendingBanner({ count }: Props) {
  const nav = useNavigate();

  if (count === 0) return null;

  return (
    <button
      type="button"
      onClick={() => nav("/inbox")}
      className="w-full text-left flex items-center gap-3 bg-warning/10 border border-warning/40 rounded-2xl p-4 mb-4 active:opacity-80 transition-opacity"
    >
      <span className="w-2 h-2 rounded-full bg-warning shrink-0" />
      <span className="flex-1 text-fg text-sm font-medium">
        {count} approval{count !== 1 ? "s" : ""} waiting for you
      </span>
      <ChevronRight size={18} className="text-warning shrink-0" />
    </button>
  );
}
